import { render, staticRenderFns } from "./buttonStyle-editor.vue?vue&type=template&id=8fa0fd5c&scoped=true&"
import script from "./buttonStyle-editor.vue?vue&type=script&lang=js&"
export * from "./buttonStyle-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa0fd5c",
  null
  
)

export default component.exports